import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		male: {
			// ?safe&mock-data&utm_source=FB&country=NZ&area=male&exp=web_en_countries_price_optimization~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_en_countries_price_optimization/male'
					),
			},
		},
		'activity-female-walking': {
			// ?safe&mock-data&utm_source=FB&country=NZ&area=activity-female-walking&exp=web_en_countries_price_optimization~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_en_countries_price_optimization/activity-female-walking'
					),
			},
		},
	},
]

export default config
